export default __webpack_public_path__ + "static/media/ed1.3a57bbb1.svg";